// extracted by mini-css-extract-plugin
module.exports = {"container":"JL-z","productName":"KL-z","modal":"LL-z","dimensions":"ML-z","recipientEmail":"NL-z","lowStock":"OL-z","recommendedFit":"PL-z","notRecommendedFit":"QL-z"};